import React from 'react';
import Head from 'next/head';
import Header from './../../components/Header';
import Footer from './../../components/Footer';
import ToolCard from './../../components/ToolCard';
import { tools } from './../../data/tools';


const Tools = ({ }) => {
    return (
        <div className="flex flex-col min-h-screen justify-between">
            <Head>
                <title>IELTS Writing Tools</title>
                <meta name="description" content="Discover our collection of tools to enhance your IELTS Writing preparation and improve your scores." />
            </Head>

            <Header />

            <h2 className="text-2xl font-semibold mt-8 text-center">Tools for IELTS preparation</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                {tools.map((tool) => (
                    <ToolCard
                        key={tool.id}
                        title={tool.title}
                        summary={tool.summary}
                        imgSrc={tool.imgSrc}
                        link={tool.link}
                        free={tool.free}
                    />
                ))}
            </div>

            <Footer />
        </div>
    );
};

export default Tools;